import React from "react";
import {LoaderSection} from "../elements/LoaderSection";
import PropTypes from 'prop-types'

// AGUS - DESACTIVAR PROMOCION

export default class CalculatorResult extends React.Component {

    
    INSTALLMENTS_INTEREST_RATES_FOOT_NOTES = {
        4: 'TNA: 58.02% - TEA: 74.90% - CTF: 78.65%\nCuotas mensuales fijas',
        5: 'TNA: 43.26% - TEA: 52.09% - CTF: 55.09%\nCuotas mensuales fijas',
        6: 'TNA: 28% - TEA: 31.48% - CTF: 34.98%\nCuotas mensuales fijas',
        12: 'TNA: 32% - TEA: 37.14% - CTF: 45.14%\nCuotas mensuales fijas'
    }

    advancePayment() {
        return Math.round(this.props.amountInAdvance);
    }

    feesAmount() {
        return this.props.feesAmount
    }

    renderInstallmentsAdvancePayment() {
        const isOnePayment = this.props.feesQuantity < 3;
        const isThreePayments = this.props.feesQuantity === 3;
        return (
            <div className="advance-payment-container">
                {isOnePayment ? (
                    <p className="advance-payment-text">
                        <span className="highlight-numbers" style={{fontSize: '1em'}}>1</span> <span style={{color: 'white', marginLeft: '5px', fontSize: '13.5px'}}>pago</span>
                    </p>
                ) : isThreePayments ? (
                    <p className="advance-payment-text">1ra cuota</p>
                ) : (
                    <p className="advance-payment-text">Anticipo</p>
                )}
                <br />
                <p className="advance-payment-amount">${this.advancePayment().toLocaleString()}</p>
            </div>
        );
    }

    _renderTotalFee(totalAmount, cssClass, itsFinanced = false) {
        const title = itsFinanced ? 'Costo Total del servicio financiado' : 'Total costo por servicio'
        return <div className={cssClass}>
            <p>{title}:</p>
            <p>${totalAmount.toLocaleString()}</p>
        </div>
    }

    renderFeesPayment(feesQuantity, feesAmount) {
        return <div className="amount-paids">
            <div className="paid-number">
                <p className="highlight-numbers">{feesQuantity}</p>
                <p>cuotas de</p>
            </div>
            <p className="highlight-numbers total">${feesAmount.toLocaleString()}</p>
        </div>;
    }

    // Mercadopago installment plan chosen

    _isPreferentialInstallmensSelected() {
        return this.props.feesQuantity > 1 && this.props.feesQuantity < 4;
    }

    // Cash selected

    _isCashPaymentSelected() {
        return this.props.feesQuantity === 1;
    }

    renderCashTotal() {
        return (
            <div className="total-paid mercadopago-total-footer">
                <div className="amount-paids">
                    <div className="paid-number">
                        <p>Costo original del Servicio</p>
                    </div>
                    <p className="total">${this.props.totalFeeAmountWithoutDiscounts.toLocaleString()}</p>
                </div>
                <div className="amount-paids">
                    <div className="paid-number">
                        <p> Descuento {this.props.discountPercentage.toLocaleString()}%</p>
                    </div>
                    <p className="total">-${this.props.discountFee.toLocaleString()}</p>
                </div>
                {this._renderTotalFee(this.totalAmountForCashPayment(), "amount-paids")}
            </div>
        );
    }

    renderInstallmentsTotal() {
        return (
            <div className="total-paid mercadopago-total-footer">
                <div className="amount-paids">
                    <div className="paid-number">
                        <p>Costo original del Servicio</p>
                    </div>
                    <p className="total">${this.props.totalFeeAmountWithoutDiscounts.toLocaleString()}</p>
                </div>
                <div className="amount-paids">
                    <div className="paid-number">
                        <p> Descuento aplicado (10%)</p>
                    </div>
                    <p className="total">-${this.props.discountFee.toLocaleString()}</p>
                </div>
                {this._renderTotalFee(this.props.totalAmount, "amount-paids")}
            </div>
        );
    }

    renderCashPayment(amount, isACashPayment = true) {
        return <React.Fragment>
            <div className="amount-paids">
                <div className="paid-number">
                    <p className="highlight-numbers">1</p>
                    <p>pago</p>
                </div>
                <p className="highlight-numbers total">${amount.toLocaleString()}</p>
            </div>
            {isACashPayment ?
                <div className="amount-paids">
                    <p className="discount-note-text"> (con {this.props.discountPercentage}% de descuento incluído)</p>
                </div>
                :
                <div></div>
            }
        </React.Fragment>
    }

    totalAmountForCashPayment() {
        let total = this.props.totalAmount;
        return Math.round(total);
    }

    // Render Box

    _installmentCalculatorBox(label, title, subtitle, footNote) {
        if (!this.isFeesAmountPermitted()) {
            return null
        }
        const renderAdvancePayment = this.renderInstallmentsAdvancePayment();
        const renderFees = this.renderFeesPayment(this.props.feesQuantity - 1, this.feesAmount());
        const renderTotal = this._renderTotalFee(this.props.totalAmount, "total-paid");

        const renderPromotion = this.props.feesQuantity === 12 ? this.cashPaymentFootNote() : null;
        return this._calculatorBox(label, title, subtitle, renderFees, renderTotal, footNote, renderAdvancePayment, renderPromotion);
    }

    _installmentsCalculatorBox() {
        const title = this.props.feesQuantity > 6 ? `${this.props.feesQuantity} cuotas` : `Hasta ${this.props.feesQuantity} cuotas`;
        const className = this.props.feesQuantity > 6 ? "twelve-label" : "mp-label";
        const footNote = this._feesQuantityFootNote();
        return this._installmentCalculatorBox(className, title, '', footNote);
    }

    _feesQuantityFootNote() {
        const defaultFeesAmount = this.feesAmount() === 0;
        const feesQuantity = this.props.feesQuantity;
        return defaultFeesAmount ? '' : this.INSTALLMENTS_INTEREST_RATES_FOOT_NOTES[feesQuantity];
    }

    _upToThreeInstallmentsCalculatorBox() {
        if (!this.isFeesAmountPermitted()) {
            return null
        }
        const title = `10% OFF `;
        const subtitle = `${this.props.feesQuantity} cuotas sin interés`;
        const renderAdvancePayment = this.renderInstallmentsAdvancePayment();
        const renderFees = this.renderFeesPayment(this.props.feesQuantity - 1, this.feesAmount());
        const renderTotal = this.renderInstallmentsTotal();
        
        return this._calculatorBox("installment-label", title, subtitle, renderFees, renderTotal, '', renderAdvancePayment);
    }

    _cashCalculatorBox() {
        let title = `${this.props.discountPercentage}% OFF `;
        let subtitle = `Pago de contado`;
        let renderFees = this.renderCashPayment(this.totalAmountForCashPayment(), true);
        let renderTotal = this.renderCashTotal();
        let renderPromotion = this.cashPaymentFootNote();
        return this._calculatorBox("cash-label", title, subtitle, renderFees, renderTotal, undefined, undefined, renderPromotion);
    }

    cashPaymentFootNote() {
        // Pasarlo a un único lugar
        const today = new Date();
        const month = today.getMonth() + 1;
        const year = today.getFullYear();
        const day = new Date(year, month, 0).getDate();
        return `Promoción válida hasta el ${day}/${month}/${year}`;
        // return `Promoción válida hasta el 07/07/2024`;
    }

    renderLoadingBox() {
        return (
            <div className="information-paids-box  col m6 col s12">
                <LoaderSection/>
            </div>
        )
    }

    isFeesAmountPermitted() {
        return this.props.isFeesAmountPermitted
    }

    renderBoxContent(renderFees, renderTotal, footNote, renderAdvancePayment, renderPromotion) {
        return (
            <div className="information-paids-box col m6 col s12">
                {renderAdvancePayment}
                {renderFees}
                {renderTotal}
                <div className="calculator-footer">
                    {footNote}
                </div>
                <div className="calculator-promotion">
                    {renderPromotion}
                </div>
            </div>
        )
    }

    _calculatorBox(label, title, subtitle, renderFees, renderTotal, footNote = '', renderAdvancePayment = undefined, renderPromotion = undefined) {
        return (
            <div className={`calculator-control-result ${label}`}>
                <div className="calculator-control-header">
                    <div className="calculator-control-label">{title}</div>
                    <div className="calculator-control-subtitle">{subtitle}</div>
                </div>
                {this.props.loading ? this.renderLoadingBox() : this.renderBoxContent(renderFees, renderTotal, footNote, renderAdvancePayment, renderPromotion, renderPromotion)}
            </div>
        );
    }

    render() {
        if (this._isPreferentialInstallmensSelected()) {
            return this._upToThreeInstallmentsCalculatorBox();
        }
        if (this._isCashPaymentSelected()) {
            return this._cashCalculatorBox()
        }
        return this._installmentsCalculatorBox()
    }
}

CalculatorResult.propTypes = {
    mercadoPagoSurchargePercentage: PropTypes.number,
    loading: PropTypes.bool,
    discountPercentage: PropTypes.number,
    mercadoPagoDiscount: PropTypes.number,
    feesQuantity: PropTypes.number,
    totalAmount: PropTypes.number,
    feesAmount: PropTypes.number,
    amountInAdvance: PropTypes.number,
    totalFeeAmountWithoutDiscounts: PropTypes.number,
    discountFee: PropTypes.number,
    isFeesAmountPermitted: PropTypes.bool
}